import { useTheme } from '@emotion/react';
import { ContentCopyOutlined, CopyAllOutlined, FileCopy } from '@mui/icons-material'
import { Autocomplete, capitalize, Chip, CircularProgress, Dialog, Divider, Grid, IconButton, InputAdornment, MenuItem, Modal, Paper, TextField, Tooltip, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles';
import { ReactComponent as CloseIcon } from "assets/close_icon.svg";
import { FetchRoundAllInvestorsEmails, FetchRoundInvestorsData } from 'api/round';
import EmailAutocomplete from 'common-components/EmailAutocomplete';
import { Field, FormikProvider, useFormik } from 'formik';
import React from 'react'
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import CustomAutoComplete from 'ui-components/CustomAutoComplete';
import CustomValidationText from 'ui-components/CustomValidationText';
import CustomInputField from 'ui-components/CustomInputField';
import ModalComponent from 'ui-components/ModalComponent';
import { handleCopyClick } from 'utils/index';
import * as Yup from "yup";
import { Primary } from 'ui-components/Buttons';
const useStyles = makeStyles({
    customInput: {
        // '&  > div.MuiInputBase-root': {
        //     padding: 0
        // }
    }
});

let emailPattern = /^[^\s@]+@[^\s@]+.[^\s@]+$/;

const MoveToPipelineFlowPopup = ({ open, handleClose, handleSubmission, isCreating = false, options = [], currentPipelineID = null }) => {

    const theme = useTheme();
    // const { id: round_id } = useParams();
    const classes = useStyles();
    const details = useSelector((state) => state?.investorDetails?.data);
    const investor_id = useSelector(state => state?.investorDetails?.data?._id);
    const filteredOptions = options?.filter(item => item?.value !== "All")
    // console.log(details,"details")
    // const { data: personData, refetch: refetchListingLisiting, isLoading: isLoadingRoundInvestors } = FetchRoundAllInvestorsEmails({ id: round_id });
    // console.log(personData?.data?.map(item => ({name: item?.name, email: item?.email})), "personData")
    const formik = useFormik({
        initialValues: {
            status: null,
        },
        validationSchema: Yup.object({
            status: Yup.object().required("Please select pipeline"),
            // email: Yup.string()
            // .required("Please enter email")
            // .test("email", "Invalid email address", (value) => emailPattern.test(value)),
        }),
        validateOnBlur: false,
        validateOnChange: false,
        validateOnMount: false,
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            const payload = {
                // "startup_id": details?._id,
                // "startup_round_id": round_id,
                // "email": String(values?.email)?.toLowerCase(),
                // "message": values?.email,
                // investor_id: investor_id,
                // "deal_flow_name": capitalize(values?.status)?.trim()
                status: values?.status?.label,
                status_value: values?.status?.value,
                pipeline_id: currentPipelineID
            }
            await handleSubmission({ ...payload })

        },
    });

    const [copied, setCopied] = React.useState(false)


    return (
        <ModalComponent open={open} onClose={handleClose} style={{ maxWidth: "500px", width: "100%" }}>
            <Paper
                sx={{
                    background: theme.palette.customColors.whiteBG,
                    borderRadius: "8px",
                }}
            >
                <IconButton sx={{ position: "absolute", top: 20, right: 20, padding: 0 }}>
                    <CloseIcon width={40} height={40} onClick={handleClose} />
                </IconButton>
                <FormikProvider value={formik}>
                    <form onSubmit={formik.handleSubmit} onKeyDown={(e) => {
                        if ((e.key === "Enter" && !e.shiftKey)) {
                            e.preventDefault();
                        }
                    }}>
                        <Grid display={"grid"} container padding={"1.5rem"} gap={"1.5rem"}>
                            <Grid item xs={12}>
                                <Typography
                                    sx={{
                                        fontSize: "1.5rem",
                                        fontWeight: 700,
                                        lineHeight: "28px",
                                        color: theme.palette.customColors.g300,
                                    }}
                                >
                                    Move to Pipeline
                                </Typography>
                            </Grid>
                            {/* {console.log(details,"details")} */}
                            <Grid item xs={12}>
                                <Grid item xs={12} container justifyContent={"space-between"}>
                                    <Grid item xs={12}>
                                        {/* <CustomInputField
                                            name="status"
                                            label={"Name"}
                                            placeholder={"Enter flow name"}
                                            value={capitalize(formik?.values?.status)}
                                            sx={{ marginBottom: 1 }}
                                            tabIndex={1}
                                        /> */}
                                        <Autocomplete
                                            autoComplete="off"
                                            disablePortal
                                            options={filteredOptions}
                                            fullWidth
                                            autoHighlight
                                            value={formik.values.status}
                                            getOptionLabel={(option) => capitalize(option.label) || ""} // 👈 Add this line
                                            renderOption={(props, option) => (
                                                <MenuItem {...props}>
                                                    {capitalize(option?.label)}
                                                </MenuItem>
                                            )}
                                            onChange={(e, newValue) => {
                                                // console.log(newValue);
                                                formik.setFieldValue("status", newValue);
                                                // Handle selection logic here
                                            }}
                                            renderInput={(params) => (
                                                <CustomInputField
                                                    variant="outlined"
                                                    placeholder="Select Pipeline"
                                                    {...params}
                                                    sx={{ marginBottom: 0 }}
                                                    className="filter-autocomplete"
                                                    hasError={formik.errors?.status}
                                                    errorMessage={formik.errors?.status}
                                                />
                                            )}
                                        />

                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Primary
                                    type="submit"
                                    fullWidth
                                    sx={{ padding: "0.75rem 1.25rem", fontSize: "1rem", height: '52px' }}
                                    disabled={isCreating}
                                >
                                    {isCreating ? <CircularProgress sx={{ color: "white", marginInline: 'auto' }} size={'1.2rem'} /> : "Save"}
                                </Primary>
                            </Grid>
                        </Grid>
                    </form>
                </FormikProvider>
            </Paper>
        </ModalComponent>
    )
}

export default MoveToPipelineFlowPopup